import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import Text from 'components/Core/Text';
import HyperLink from 'components/Core/HyperLink';
import { STGlyphTertiary } from 'components/Brand/Logos/STGlyph';
import { STIcon } from 'components/Brand/Icons/STIcon';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import { GetDemoLink, GetDemoContainer } from './styles';

const GetDemo = ({ url, showDetailedGetDemo, customCta }) => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  const basicGetDemoProps = {
    href: url,
    ...(!url && { onClick: () => toggleIsModalOpen(true) }),
  };

  const detailedGetDemoProps = {
    title: 'Over 7,500 contractors use ServiceTitan for their businesses.',
    bullets: [
      'Switching to ServiceTitan increased average revenue by 21% in their first two years.',
      'Lower cost through automation',
      'Run your business from anywhere',
    ],
    cta: {
      url: url,
      buttonLabel: 'Get a Demo',
      color: 'Critical 3',
      ...(!url && { handleClick: () => toggleIsModalOpen(true) }),
    },
  };

  if (customCta) {
    const { title, bullet1, bullet2, bullet3, cta } = customCta;
    detailedGetDemoProps.title = title;
    detailedGetDemoProps.bullets = [bullet1, bullet2, bullet3].filter((x) => !!x);
    detailedGetDemoProps.cta = cta;
    detailedGetDemoProps.cta.color = detailedGetDemoProps.cta.buttonLabel.includes('Demo')
      ? 'Critical 3'
      : 'Titan Blue 3';
  }

  return (
    <>
      {showDetailedGetDemo ? (
        <DetailedGetDemo {...detailedGetDemoProps} />
      ) : (
        <BasicGetDemo {...basicGetDemoProps} />
      )}
      <ModalMarketingForm
        isModalOpen={isModalOpen}
        onModalCancel={() => toggleIsModalOpen(false)}
        onFormSuccess={() => toggleIsModalOpen(false)}
        toggleIsModalOpen={toggleIsModalOpen}
      />
    </>
  );
};
export default GetDemo;

GetDemo.propTypes = {
  showDetailedGetDemo: PropTypes.bool,
};

GetDemo.defaultProps = {
  showDetailedGetDemo: false,
};

const BasicGetDemo = (props) => (
  <GetDemoLink className="sidebar-detailed-demo hover-borderless">
    <HyperLink {...props} data-position="Sidebar - Demo CTA">
      <STGlyphTertiary height="30px" width="33px" />
      Get a ServiceTitan demo
      <STIcon type="icon-arrow-right1" />
    </HyperLink>
  </GetDemoLink>
);

const DetailedGetDemo = ({ title, bullets, cta }) => {
  return (
    <GetDemoContainer className="sidebar-detailed-demo">
      <Text className="detailed-get-demo--title" type="h5">
        {title}
      </Text>
      <ul className="detailed-get-demo--ul">
        {bullets.map((bullet, index) => (
          <li key={index}>
            <Text type="p" size="16">
              <STIcon type="blue_check" /> {bullet}
            </Text>
          </li>
        ))}
      </ul>
      <ContentfulCallToAction {...cta} dataPosition="Sidebar - Demo CTA"></ContentfulCallToAction>
    </GetDemoContainer>
  );
};
